<!-- common header -->
<!-- <app-header-panel></app-header-panel> -->

<!-- component container -->
<router-outlet></router-outlet>